import Cookies from 'js-cookie';
import jsKit from './jsKit';

/**
 COOKIE Settings Window
 Version 1.0
 * */

/* jshint esversion: 6 */

import * as bootstrap from 'bootstrap';

export function cookiesSettings() {
    const cookiesModalID = document.querySelector('#cookiesSettingsModal');
    const cookiesRequiredBtn = cookiesModalID.querySelector('#cookiesRequiredBtn');
    const cookiesAllBtn = cookiesModalID.querySelector('#cookiesAllBtn');
    const cookiesSettingsBtn = cookiesModalID.querySelector('#cookiesSettingsBtn');
    // const cookiesRequiredSwitch = cookiesModalID.querySelector('#cookiesRequiredSwitch')
    const cookiesCustomSwitch = cookiesModalID.querySelector('#cookiesCustomSwitch');
    const cookiesStatsSwitch = cookiesModalID.querySelector('#cookiesStatsSwitch');
    const cookiesMarketingSwitch = cookiesModalID.querySelector('#cookiesMarketingSwitch');

    const value = 'granted';

    function setOnOpen() {
        cookiesCustomSwitch.checked = Cookies.get('_cookieSettingsCustom');
        cookiesStatsSwitch.checked = Cookies.get('_cookieSettingsStats');
        cookiesMarketingSwitch.checked = Cookies.get('_cookieSettingsMarketing');
    }

    function setRequired() {
        Cookies.set('_cookieSettingsRequired', value, { expires: 365 });
        Cookies.remove('_cookieSettingsCustom', value, { expires: 365 });
        Cookies.remove('_cookieSettingsMarketing', value, { expires: 365 });
        Cookies.remove('_cookieSettingsStats', value, { expires: 365 });
        cookiesCustomSwitch.checked = false;
        cookiesStatsSwitch.checked = false;
        cookiesMarketingSwitch.checked = false;
        jsKit.closeModal();
    }

    function setAll() {
        Cookies.set('_cookieSettingsRequired', value, { expires: 365 });
        Cookies.set('_cookieSettingsCustom', value, { expires: 365 });
        Cookies.set('_cookieSettingsMarketing', value, { expires: 365 });
        Cookies.set('_cookieSettingsStats', value, { expires: 365 });
        cookiesCustomSwitch.checked = true;
        cookiesStatsSwitch.checked = true;
        cookiesMarketingSwitch.checked = true;
        jsKit.closeModal();
    }

    function setSettings() {
        Cookies.set('_cookieSettingsRequired', value, { expires: 365 });
        jsKit.closeModal();
    }

    function setCustom(set) {
        if (set) {
            Cookies.set('_cookieSettingsCustom', value, { expires: 365 });
        } else {
            Cookies.remove('_cookieSettingsCustom');
        }
    }

    function setStats(set) {
        if (set) {
            Cookies.set('_cookieSettingsStats', value, { expires: 365 });
        } else {
            Cookies.remove('_cookieSettingsStats');
        }
    }

    function setMarketing(set) {
        if (set) {
            Cookies.set('_cookieSettingsMarketing', value, { expires: 365 });
        } else {
            Cookies.remove('_cookieSettingsMarketing');
        }
    }

    cookiesRequiredBtn.addEventListener('click', setRequired);
    cookiesAllBtn.addEventListener('click', setAll);
    cookiesSettingsBtn.addEventListener('click', setSettings);

    cookiesCustomSwitch.addEventListener('change', (e) => setCustom(e.target.checked));
    cookiesStatsSwitch.addEventListener('change', (e) => setStats(e.target.checked));
    cookiesMarketingSwitch.addEventListener('change', (e) => setMarketing(e.target.checked));

    Cookies.get('_cookieSettingsRequired') === '1' && Cookies.set('_cookieSettingsRequired', value, { expires: 365 });
    Cookies.get('_cookieSettingsCustom') === '1' && Cookies.set('_cookieSettingsCustom', value, { expires: 365 });
    Cookies.get('_cookieSettingsStats') === '1' && Cookies.set('_cookieSettingsStats', value, { expires: 365 });
    Cookies.get('_cookieSettingsMarketing') === '1' && Cookies.set('_cookieSettingsMarketing', value, { expires: 365 });

    setOnOpen();

}
